<!--  -->
<template>
  <div class="boxr">
    <div class="search_box">
      <div class="search_box">
        <div>
          <el-select v-model="pageIfon.platform_id" placeholder="请选择平台">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </div>
        <div>
          <el-input v-model="pageIfon.title" placeholder="请输入标题" />
        </div>
        <div>
          <el-select v-model="pageIfon.onlyMe" style="margin-right:10px" placeholder="请选择">
            <el-option
              v-for="item in accountarr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div>
          <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <el-button type="info" icon="el-icon-refresh-right" @click="reast">重置</el-button>
        </div>
      </div>

      <div>
        <!-- <el-button type="success" icon="el-icon-plus" style="margin-bottom:10px" @click="addmassdispatch">新增群发模板</el-button> -->
        <el-dropdown style="margin-bottom:10px">
          <el-button type="primary">
            新增群发模板<i class="el-icon-arrow-down el-icon--right" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item><el-button type="primary" style="margin-bottom:10px" @click="addmassdispatch">图文模板</el-button></el-dropdown-item>
            <el-dropdown-item><el-button type="primary" style="margin-bottom:10px" @click="addtextdispatch">文本模板</el-button></el-dropdown-item>
            <!-- <el-dropdown-item><el-button type="primary" style="margin-bottom:10px" @click="addaudiodispatch">音频模板</el-button></el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>
      </div>

    </div>
    <!-- <el-table
      :data="imgarrs"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="title"
        label="标题"
        width="300"
        align="center"
      />
      <el-table-column
        prop="platform_name"
        label="所属平台"
        align="center"
      />
      <el-table-column
        align="center"
        prop="type"
        label="类型"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.type===1">图文</span>
          <span v-if="scope.row.type===2">文本</span>
          <span v-if="scope.row.type===3">音频</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="real_name"
        label="创建人"
        width="180"
        align="center"
      />
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        align="center"
      />
      <el-table-column
        align="center"
        prop="work_status"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" style="margin-bottom:10px" @click="editwe(scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" style="margin-bottom:10px" @click="deleter(scope.row.id)">删除</el-button>
          <el-button type="warning" size="mini" style="margin-bottom:10px" @click="multiplexing(scope.row.id)">复用</el-button>
        </template>
      </el-table-column>
    </el-table> -->
    <div class="allboxwe">
      <div v-for="item,index in imgarrs" :key="index" class="dssakse">
        <div v-if="item.type ==1 && item.articles.length>5" class="tewr_aerbox" @click="bot(index)">
          <i class="el-icon-bottom" />
        </div>
        <div ref="contentData" class="daswrw" style="margin-right: 15px;margin-bottom:15px;max-height:410px;overflow-y: scroll;">
          <div class="tewr_box" :style="{ paddingBottom: item.articles.length > 1 ? '5px' : '0px' }">
            <div v-for="items,indexr in item.articles" :key="indexr">
              <div v-if="item.type == 1">
                <div v-if="indexr == 0" class="onebox">
                  <img class="onebox_img" :src="items.srv" alt="" :style="{ borderRadius: item.articles.length > 1 ? '6px 6px 0px 0px' : '6px' }">
                  <div class="onebox_imgr">{{ items.title }}</div>
                  <el-dropdown class="deopview" @command="(command)=>handleCommand(command,item)">
                    <span class="el-dropdown-link">
                      操作<i class="el-icon-arrow-down el-icon--right" />
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="a">编辑</el-dropdown-item>
                      <el-dropdown-item command="b">删除</el-dropdown-item>
                      <el-dropdown-item command="c">复用</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-tag class="deopviewr" size="small">
                    <div class="tiower">
                      <div :title="item.title" class="tiotext">{{ item.title }}</div>
                      <div>（{{ item.platform_name }}）</div>
                    </div>
                  </el-tag>
                </div>
                <div v-else>
                  <div class="itemwew">
                    <div class="itemwew_title">
                      {{ items.title }}
                    </div>
                    <img class="onebox_srv" :src="items.srv" alt="">
                  </div>
                  <div class="line" />
                </div>

              </div>
              <div v-else>
                <div class="oneboxrr">
                  <!-- <div v-html="item.articles[0].content.replace(/\n/g,'<br>')" /> -->
                  <div v-html="srt(item.articles[0].content).replace(/\n/g,'<br>')" />
                  <el-dropdown class="deopview" @command="(command)=>handleCommand(command,item)">
                    <span class="el-dropdown-linkr">
                      操作<i class="el-icon-arrow-down el-icon--right" />
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="a">编辑</el-dropdown-item>
                      <el-dropdown-item command="b">删除</el-dropdown-item>
                      <el-dropdown-item command="c">复用</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-tag class="deopviewr" size="small">
                    <div class="tiower">
                      <div :title="item.title" class="tiotext">{{ item.title }}</div>
                      <div>（{{ item.platform_name }}）</div>
                    </div>
                  </el-tag>
                </div>
              </div>
            </div>
          <!-- <div @click="top(index)">
            <i class="el-icon-top" />
          </div> -->
          </div>
        </div>
      </div>

    </div>

    <pagination-right
      :current-page="pageIfon.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { accountlist, atemplatedeletion, strategyPlatform, multiplexingtion } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      imgarrs: [],
      total: null,
      pageIfon: {
        page: 1,
        pageSize: 10,
        platform_id: null,
        title: null,
        onlyMe: 2
      },
      accountarr: [{
        value: 1,
        label: '查看组内模板'
      }, {
        value: 2,
        label: '我创建的模板'
      }],
      options: []
    }
  },
  activated() {
    this.acounewlist()
  },
  created() {
    this.acounewlist()
    this.platelist()
  },
  mounted() {

  },
  methods: {
    async platelist() {
      const data = await strategyPlatform()
      this.options = data.data.list
      console.log('data', data)
    },
    async acounewlist() {
      const data = await accountlist(this.pageIfon)
      this.imgarrs = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.acounewlist()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.acounewlist()
    },
    search() {
      this.pageIfon.page = 1
      this.acounewlist()
    },
    reast() {
      this.pageIfon.page = 1
      this.pageIfon.pageSize = 10
      this.pageIfon.platform_id = null
      this.pageIfon.title = null
      this.pageIfon.onlyMe = 2
      this.acounewlist()
    },
    editwe(item) {
      console.log('editweitem', item)
      // this.$router.push({ path: '/accountPush/index', query: { title: item.title, arr: item.articles, id: item.id, platform_id: item.platform_id }})
      if (item.type === 1) {
        this.$router.push({ path: '/accountPush/index', query: { id: item.id }})
      }
      if (item.type === 2) {
        this.$router.push({ path: '/textTemplate/index', query: { id: item.id }})
      }
      if (item.type === 3) {
        this.$router.push({ path: '/audioTemplate/index', query: { id: item.id }})
      }
    },
    addmassdispatch() {
      this.$router.push({ path: '/accountPush/index' })
    },
    addtextdispatch() {
      this.$router.push({ path: '/textTemplate/index' })
    },
    addaudiodispatch() {
      this.$router.push({ path: '/audioTemplate/index' })
    },
    deleter(id) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        atemplatedeletion({
          id: id
        }).then((res) => {
          console.log('res', res)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.acounewlist()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    multiplexing(id) {
      this.$confirm('确定要复用吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        multiplexingtion({
          article_template_id: id
        }).then((res) => {
          console.log('res', res)
          this.$message({
            type: 'success',
            message: '复用成功!'
          })
          this.acounewlist()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    handleCommand(command, item) {
      // eslint-disable-next-line eqeqeq
      if (command == 'a') {
        console.log(command, item)
        this.editwe(item)
      // eslint-disable-next-line eqeqeq
      } else if (command == 'b') {
        console.log(command, item)
        this.deleter(item.id)
      } else {
        console.log(command, item)
        this.multiplexing(item.id)
      }
    },
    srt(str) {
      return str.replace(/<a(.*?)>/g, '<a$1 target="_blank" rel="noopener noreferrer">')
    },
    top(index) {
      console.log(this.$refs.contentData[index].scrollTop)
      let top = this.$refs.contentData[index].scrollTop || document.body.scrollTop
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = this.$refs.contentData[index].scrollTop = top -= 50
        if (top <= 0) {
          clearInterval(timeTop)
        }
      }, 10)
    },
    bot(index) {
      document.getElementsByClassName('daswrw')[index].scrollTo({ top: document.getElementsByClassName('daswrw')[index].scrollHeight, behavior: 'smooth' })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.boxr{
  padding: 20px;
}
.search_boxr{
  justify-content: space-between;
}
.search_box{
  display: flex;
}
.tewr_box{
  width: 300px;
  /* height: 500px; */
  border: 1px solid #e9e9e9;
  border-radius: 10px;
  margin-bottom: 10px;
}
.dssakse{
  position: relative;
}
.tewr_aerbox{
  position: absolute;
    bottom: 30px;
    left: 134px;
    z-index: 999;
    cursor: pointer;
}
.onebox{
  width: 100%;
  height: 130px;
  /* border: 1px solid red; */
  position: relative;
}
.oneboxrr{
  width: 100%;
  /* height: 130px; */
  /* border: 1px solid red; */
  position: relative;
  text-align: center;
  padding: 50px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
.onebox_img{
  width: 298px;
  height: 130px;
  /* border-radius: 6px 6px 0px 0px; */
}
.onebox_imgr{
  position: absolute;
  bottom: 10px;
  left: 5px;
  color: white;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 270px;
  font-size: 15px;
}
.onebox_srv{
  height: 50px;
  width: 50px;
}
.itemwew_title{
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 216px;
  font-size: 13px;
  height: 36px;
}
.itemwew{
  display: flex;
  padding: 0px 10px;
  align-items: center;
  margin-top: 10px;
  justify-content: space-around;
}
.line{
  width: 200px;
  height: 1px;
  background: #e5e5e5;
  margin-left: 10px;
  margin-top: 5px;
}
.allboxwe{
  display: flex;
  flex-wrap: wrap;
}
.el-dropdown-link {
    cursor: pointer;
    color: white;
  }
  .el-dropdown-linkr{
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .demonstration {
    display: block;
    color: #8492a6;
    font-size: 14px;
    margin-bottom: 20px;
  }
  .deopview{
position: absolute;
top: 7px;
    right: 10px;
  }
  .deopviewr{
    position: absolute;
top: 3px;
    left: 5px;
  }
  .tiower{
    display: flex;
    align-items: center;
  }
  .tiotext{
    max-width: 140px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .daswrw{
    position: relative;
  }
  ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        background-color: rgba(0,0,0,.2);
        display: none;
    }

    /*定义滚动条轨道
 内阴影+圆角*/
    ::-webkit-scrollbar-track
    {
        -webkit-box-shadow:inset 0 0 6px rgba(0,0,0,0.3);
        border-radius:10px;
        background-color:#F5F5F5;
    }
    /*定义滑块
     内阴影+圆角*/
    ::-webkit-scrollbar-thumb
    {
        border-radius:10px;
        -webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.3);
        background-color: #b3b3b3;
    }

    @media (max-width: 768px){
      .allboxwe{
        justify-content: center;
      }
      .onebox{
        height:150px;
        img{
          height:100%;
        }
      }
      .search_box div{
        width:100%;
      }
    }
</style>
